import {getCookie} from 'custom-extensions/cookies';

/**
 * @returns {import('custom-extensions/search/lib/api/types').SearchRequestFilter[]}
 */
export const rallyHouseFilterList = () => {
	const activeHotMarkets = window.mivaJS?.ActiveHotMarkets;
	const availgroups = window.mivaJS?.availgroups;
	const backgroundFilters = window.mivaJS?.Search_Background_Filters ?? [];

	// Exclude "hot_market" items
	const filters = [
		{
			background: true,
			field: 'hot_market',
			value: 'False'
		}
	];

	// eslint-disable-next-line no-process-env
	if (process.env.NODE_ENV !== 'production') {
		// Apply the site domains filter for DEVELOPMENT builds only
		const xLocalProxyDomain = getCookie('xLocalProxyDomain');

		if (xLocalProxyDomain) {
			filters.push({
				background: true,
				field: 'site_domains',
				value: xLocalProxyDomain
			});
		}
	}

	// Add Active Hot Market filters
	for (let hotmarket of activeHotMarkets ?? []) {
		filters.push({
			background: true,
			field: 'hot_market',
			value: hotmarket.value
		});
	}

	// Add Availability Groups filters
	for (let availgroup of availgroups ?? []) {
		filters.push({
			background: true,
			field: 'availability_groups',
			value: availgroup.toString()
		});
	}

	// Apply domain background filters
	for (const filter of backgroundFilters) {
		const values = Array.isArray(filter.value) ? filter.value : [filter.value];

		for (const value of values) {
			filters.push({
				background: true,
				field: filter.field,
				value
			});
		}
	}

	return filters;
};

export const rallyHouseFilters = (client) => {
	for (const filter of rallyHouseFilterList()) {
		client.backgroundFilter(filter.field, filter.value);
	}
};
